import { Component, OnInit, ViewChild } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { isEqual } from 'lodash-es';
import { Observable } from 'rxjs';
import {
  RefetchCopayIfNeeded,
  RefetchDosAndCopayIfNeeded,
} from 'src/app/core/store/order-wizard/order-wizard-data/order-wizard-data.actions';
import { OrderWizardDataState } from 'src/app/core/store/order-wizard/order-wizard-data/order-wizard-data.state';
import {
  ProductItemDohUserData,
  ProductItemQuantityUserData,
} from 'src/app/core/store/order-wizard/order-wizard-data/order-wizard-data.model';
import { CcsSentryError } from 'src/app/core/store/utils';
import { InsuranceRequirementsComponent } from './insurance-requirements/insurance-requirements.component';

@Component({
  selector: 'app-products-step',
  templateUrl: './products-step.component.html',
  styleUrls: ['./products-step.component.scss'],
})
export class ProductsStepComponent implements OnInit {
  @Select(OrderWizardDataState.isProductsStepLoading) isProductsStepLoading$!: Observable<boolean>;
  @Select(OrderWizardDataState.productsStepError) productsStepError$!: Observable<CcsSentryError | null>;
  @Select(OrderWizardDataState.hasInsuranceRequirements) hasInsuranceRequirements$!: Observable<boolean>;

  dohUserDataSnapshot: ProductItemDohUserData[] | null = null;
  quantitiesUserDataSnapshot: ProductItemQuantityUserData[] | null = null;

  @ViewChild(InsuranceRequirementsComponent) insuranceRequirementsComponent!: InsuranceRequirementsComponent;

  constructor(private store: Store) {}

  ngOnInit() {
    this.updateUserDataSnapshots();
  }

  updateUserDataSnapshots() {
    this.dohUserDataSnapshot = this.store.selectSnapshot(OrderWizardDataState.productItemDohUserData);
    this.quantitiesUserDataSnapshot = this.store.selectSnapshot(OrderWizardDataState.productItemQuantitiesUserData);
  }

  onSubmit(): boolean {
    const hasInsuranceRequirements = this.store.selectSnapshot(OrderWizardDataState.hasInsuranceRequirements);

    const areUiFormsValid = hasInsuranceRequirements ? this.insuranceRequirementsComponent.onSubmit() : true;
    if (!areUiFormsValid) return false;

    const haveDohChanged = !isEqual(
      this.dohUserDataSnapshot,
      this.store.selectSnapshot(OrderWizardDataState.productItemDohUserData)
    );

    const haveQuantitiesChanged = !isEqual(
      this.quantitiesUserDataSnapshot,
      this.store.selectSnapshot(OrderWizardDataState.productItemQuantitiesUserData)
    );

    if (haveDohChanged || haveQuantitiesChanged) {
      if (haveDohChanged) {
        this.store.dispatch(new RefetchDosAndCopayIfNeeded(haveQuantitiesChanged));
      } else if (haveQuantitiesChanged) {
        this.store.dispatch(new RefetchCopayIfNeeded(null, true));
      }

      this.updateUserDataSnapshots();
    }

    return true;
  }
}
